import React, { useEffect, useState } from "react";
import { getQuestionnaires, postQuestionnaireResponseForm } from "../api/utils";
import "../assets/stylesheets/bootstrap.min.css";
import "../assets/stylesheets/style.css";
import "../assets/stylesheets/responsive.css";
import { useParams } from "react-router-dom";
import titleize from "titleize";

export default function QuestionnaireList() {
  const [questionnaires, setQuestionnaires] = useState([]);
  const [loading, setLoading] = useState(true);
  const [answers, setAnswers] = useState({});
  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  const { token, id } = useParams();
  const userId = 9;

  const titleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getQuestionnaires(token, id);
        if (data.message === "You have already submitted your responses.") {
          setAlreadySubmitted(true);
        } else {
          setQuestionnaires(data);
        }
      } catch (err) {
        console.error("Error fetching questionnaires:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token, id]);

  // Handlers
  const handleInputChange = (questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const handleCheckboxChange = (questionId, option) => {
    setAnswers((prev) => {
      const current = prev[questionId] || [];
      const exists = current.find((item) => item.optionId === option.id);
      let updated;
      if (exists) {
        updated = current.filter((item) => item.optionId !== option.id);
      } else {
        updated = [...current, { optionId: option.id, extra_text: "" }];
      }
      return { ...prev, [questionId]: updated };
    });
  };

  const handleRadioChange = (questionId, option) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: { optionId: option.id, extra_text: "" },
    }));
  };

  const handleExtraTextChange = (questionId, optionId, value) => {
    setAnswers((prev) => {
      const current = prev[questionId];
      if (Array.isArray(current)) {
        const updated = current.map((item) =>
          item.optionId === optionId ? { ...item, extra_text: value } : item,
        );
        return { ...prev, [questionId]: updated };
      } else {
        return { ...prev, [questionId]: { ...current, extra_text: value } };
      }
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formattedAnswers = [];

    questionnaires.forEach((q) => {
      q.questions.forEach((question) => {
        const answer = answers[question.id];

        if (question.question_type === "open") {
          formattedAnswers.push({
            questionnaire: q.id,
            question: question.id,
            open_ended_answer: answer || "",
            selected_option: null,
            extra_text: null,
          });
        } else if (question.allow_multiple) {
          (answer || []).forEach((item) => {
            formattedAnswers.push({
              questionnaire: q.id,
              question: question.id,
              selected_option: item.optionId,
              open_ended_answer: null,
              extra_text: item.extra_text || null,
            });
          });
        } else {
          if (answer) {
            formattedAnswers.push({
              questionnaire: q.id,
              question: question.id,
              selected_option: answer.optionId,
              open_ended_answer: null,
              extra_text: answer.extra_text || null,
            });
          }
        }
      });
    });

    try {
      await postQuestionnaireResponseForm({ answers: formattedAnswers }, id);
      setRegistrationStatus("success");
    } catch (err) {
      console.error("Error submitting:", err);
      setRegistrationStatus("fail");
    }
  };

  const allQuestionsAnswered = () => {
    return questionnaires.every((q) =>
      q.questions.every((question) => {
        const answer = answers[question.id];
        if (question.question_type === "open") {
          return answer && answer.trim() !== "";
        } else if (question.allow_multiple) {
          return answer && answer.length > 0;
        } else {
          return answer !== undefined && answer !== null;
        }
      }),
    );
  };

  if (alreadySubmitted) {
    return (
      <div
        className="container"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <div className="top-footer" style={{ width: "75%" }}>
          <div className="row justify-content-center">
            <div
              className="col-lg-8 text-center"
              style={{ paddingTop: 150, paddingBottom: 150 }}
            >
              <div className="card p-4 p-md-5">
                <h4 className="tc-primary head-font mb-4">Notice</h4>
                <div className="icon-wrapper mb-4">
                  <i
                    className="fas fa-exclamation-circle"
                    style={{ fontSize: "64px", color: "#ffc107" }}
                  ></i>
                </div>
                <p className="fs-24 mb-4" style={{ color: "#495057" }}>
                  You have already submitted your responses!
                </p>
                <p className="mb-4" style={{ color: "#0A2458" }}>
                  Thank you for your participation. You cannot submit the form
                  again.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (registrationStatus === "success") {
    return (
      <div
        className="container"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <div className="top-footer" style={{ width: "75%" }}>
          <div className="row justify-content-center">
            <div
              className="col-lg-8 text-center"
              style={{ paddingTop: 150, paddingBottom: 150 }}
            >
              <div className="card p-4 p-md-5">
                <h4 className="tc-primary head-font mb-4">Thank You!</h4>
                <div className="icon-wrapper mb-4">
                  <i
                    className="fas fa-check-circle"
                    style={{ fontSize: "64px", color: "#28a745" }}
                  ></i>
                </div>
                <p className="fs-24 mb-4" style={{ color: "#495057" }}>
                  Your responses were submitted successfully!
                </p>
                <p className="mb-4" style={{ color: "#0A2458" }}>
                  We've saved your responses please check your inbox for more
                  details.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <main className="wrapper">
        <section className="page-hero-sec">
          <div className="container text-center">
            {questionnaires.map((q, index) => (
              <div key={index}>
                <h1 className="tc-primary head-font">{q.title}</h1>
                <h2 className="tc-primary fs-20">
                  Fill out the questions below
                </h2>
              </div>
            ))}
          </div>
        </section>

        <hr className="hr-double" />

        <section className="container py-5">
          {loading ? (
            <p>Loading...</p>
          ) : questionnaires.length > 0 ? (
            <form onSubmit={handleSubmit}>
              {questionnaires.map((q) => (
                <div key={q.id} className="mb-4">
                  {q.questions.map((question) => (
                    <div key={question.id} className="mb-3">
                      {titleize(question.question_text)}

                      {question.question_type === "open" ? (
                        <textarea
                          className="form-control"
                          rows="3"
                          value={answers[question.id] || ""}
                          onChange={(e) =>
                            handleInputChange(question.id, e.target.value)
                          }
                        />
                      ) : question.allow_multiple ? (
                        question.options.map((option) => {
                          const isChecked = answers[question.id]?.some(
                            (item) => item.optionId === option.id,
                          );
                          const extraText =
                            answers[question.id]?.find(
                              (item) => item.optionId === option.id,
                            )?.extra_text || "";

                          return (
                            <div key={option.id} className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`q${question.id}_opt${option.id}`}
                                checked={isChecked || false}
                                onChange={() =>
                                  handleCheckboxChange(question.id, option)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`q${question.id}_opt${option.id}`}
                              >
                                {option.option_text}
                              </label>

                              {option.show_extra_field && isChecked && (
                                <input
                                  type="text"
                                  className="form-control mt-1"
                                  placeholder="Enter details"
                                  value={extraText}
                                  onChange={(e) =>
                                    handleExtraTextChange(
                                      question.id,
                                      option.id,
                                      e.target.value,
                                    )
                                  }
                                />
                              )}
                            </div>
                          );
                        })
                      ) : (
                        question.options.map((option) => {
                          const isSelected =
                            answers[question.id]?.optionId === option.id;
                          const extraText = isSelected
                            ? answers[question.id]?.extra_text
                            : "";

                          return (
                            <div key={option.id} className="form-check">
                              <input
                                type="radio"
                                className="form-check-input"
                                name={`question_${question.id}`}
                                id={`q${question.id}_opt${option.id}`}
                                checked={isSelected || false}
                                onChange={() =>
                                  handleRadioChange(question.id, option)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`q${question.id}_opt${option.id}`}
                              >
                                {option.option_text}
                              </label>

                              {option.show_extra_field && isSelected && (
                                <input
                                  type="text"
                                  className="form-control mt-1"
                                  placeholder="Enter details"
                                  value={extraText}
                                  onChange={(e) =>
                                    handleExtraTextChange(
                                      question.id,
                                      option.id,
                                      e.target.value,
                                    )
                                  }
                                />
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  ))}
                </div>
              ))}

              <button
                type="submit"
                disabled={!allQuestionsAnswered()}
                className="btn btn-primary"
                style={{
                  background: "#0a2458",
                  border: "none",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                Submit Answers
              </button>
            </form>
          ) : (
            <p>No questionnaires found.</p>
          )}
        </section>
      </main>
    </div>
  );
}
